var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-fluid"},[_c('main',{staticClass:"wrapper-main"},[_c('MainContentComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }